module.exports = __webpack_public_path__ + "fonts/inter-v20-latin-300.a473493e.woff2";